export default "__VITE_PUBLIC_ASSET__df093086__"